import { LOCALIDAD_URL } from '../../config';
import axios from 'axios';


// READ
export function getLocalidades(params) {
    const {soloConOfertas} = params || {};
    const url = `${LOCALIDAD_URL}?`
        + `&soloConOfertas=${soloConOfertas ?? true}`;
    
    return axios.get(url);
};
